import { createSelector } from 'reselect';

const selectCache = (state: any) => state.announcementCache;

export const selectListAnnouncements = createSelector(
  selectCache,
  (cache: any) => cache.listAnnouncements
);

export const selectProcessing = createSelector(
  selectCache,
  (cache: any) => cache.processing
);

export const selectSuccess = createSelector(
  selectCache,
  (cache: any) => cache.success
);

export const selectProcess = createSelector(
  selectCache,
  (cache: any) => cache.process
);

export const selectSubmitting = createSelector(
  selectCache,
  (cache: any) => cache.submitting
);

export const selectAnnouncements = createSelector(
  selectCache,
  (cache: any) => cache.announcements
);
